<style scoped lang="sass">
#tray-outer
  position: absolute
  top: 0
  right: 0
  height: 100vh
  width: 100vw
  z-index: 2

  #tray
    position: absolute
    top: calc(var(--navigation-height) + var(--status-bar-height))
    right: 0
    height: calc(100vh - var(--navigation-height) - var(--status-bar-height))
    width: 90%
    background-color: var(--dark-gray)
    overflow: auto
</style>
<template>
  <transition name="tray-right" appear>
    <div id="tray-outer" @click.self.prevent="$emit('close')">
      <div id="tray">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'RightSideTray',
  data() {
    return {
      originalConfig:            Object.assign({}, this.$store.state.navigation)
    }
  },
  created() {
    this.$store.dispatch('configNavigation', {leftEnabled: false, rightEnabled: true, rightImg: 'icon-close.svg'});
    document.body.classList.add('stop-scrolling')
  },
  destroyed() {
    this.$store.dispatch('configNavigation', this.originalConfig);
    document.body.classList.remove('stop-scrolling')
  }
}
</script>
